import type { FiltersGroups } from '@/app/common/filters/core/filtersTypes.ts';
import { FILTER_NAME } from '@/app/common/filters/core/filterNames.ts';

type CreateAllFiltersFiltersGroupProps = {
  filtersGroups: FiltersGroups;
  chipGroups?: FiltersGroups;
};
export const createModalFilterGroups = ({
  filtersGroups,
  chipGroups = [],
}: CreateAllFiltersFiltersGroupProps): FiltersGroups => [
  ...chipGroups,
  ...filtersGroups.filter((group) => group.id !== FILTER_NAME.SORT),
];
